/* 
 * This is the universal drop down menubar control script.
 * 
 * Copyright 2017, Hershey Entertainment & Resorts.
 */
$(function(){
    if(dropdownShouldBeActive()) {
        Menub.Init($('ul[role=menubar]'));
    }

    $(document).on('resize', function(){
        if(dropdownShouldBeActive()) {
            Menub.Init($('ul[role=menubar]'));
        }
    });
});

var Menub = {
    menubar: null,
    topItems: null,
    topIndex: 0,
    hover: false,
    
    Init: function($menubar) {
        this.menubar = $menubar;
        this.topItems = $menubar.find('> li > a[role=menuitem]');
        
        $menubar.find('li').hoverIntent({
			over: function (e) {
                Menub.hover = true;
				Menub.DropDown.Show($(this).find('a[role=menuitem]').first());
			},
			out: function (e) {
				Menub.DropDown.Hide($(this).find('a[role=menuitem]').first());
			},
            timeout: 300
		});
        
        this.menubar.on('keydown', function(e){
            switch(e.keyCode) {
                case 32: // space bar
                    return Menub.KeyControl.ActivateLink();
                case 13: // enter key
                    if($(e.target).data('enter-follow') == true) {
                        return true;
                    }
                    return Menub.KeyControl.ActivateLink();
                case 27: // escape key
                    Menub.Goto.Parent();
                    return false;
                case 37: // left arrow
                    Menub.KeyControl.Arrow.Left();
                    return false;
                case 38: // up arrow
                    Menub.KeyControl.Arrow.Up();
                    return false;
                case 39: // right arrow
                    Menub.KeyControl.Arrow.Right();
                    return false;
                case 40: // down arrow
                    Menub.KeyControl.Arrow.Down();
                    return false;
                case 36: // home key
                    Menub.KeyControl.Home();
                    return false;
                case 35: // end key
                    Menub.KeyControl.End();
                    return false;
                case 9: // tab key
                    return true;
            }

            if(e.keyCode >= 65 && e.keyCode <= 90) {
                // Character key pressed
                Menub.Goto.NextLetter(String.fromCharCode(e.which));
                return false;
            }
        });
        
        $menubar.on('focusout', function(){
            // If not inside nav, close it
            setTimeout(function(){
                if(!Menub.menubar.find(':focus').length) {
                    Menub.DropDown.Clear();
                } 
            },150);
        });
    },
    
    Announce: function(message) {
        if($('#menu-announce').length) {
            $('#menu-announce').html(message);
        }
    },
    
    DropDown: {
        
        Show: function($menuitem) {
            if(!Menub.HasSubmenu($menuitem)) {
                return;
            }

            var $submenu = $menuitem.siblings('[data-submenu="true"]');
            $submenu.addClass('open');
            
            var args = {
                duration: 300,
                complete: function() {
                    // Set focus on first child
                    if(!Menub.hover) {
                        setTimeout(function(){
                            $submenu.find('a[role="menuitem"]').first().focus();
                        },0);
                    }
                    else {
                        Menub.hover = false;
                    }
                }
            };
            if($submenu.data('display') == 'flex') {
                args['display'] = 'flex';
            }
            
			$submenu.velocity('transition.fadeIn', args);
            // Announce menu opening
            var $menuOpening = $menuitem.parent().find('ul[role=menu]');
            if($menuOpening.length && typeof($menuOpening.attr('aria-label')) !== 'undefined') {
                Menub.Announce($menuOpening.attr('aria-label')+' Submenu Opened');
            }
            else {
                Menub.Announce('Submenu Opened');
            }
            $menuitem.addClass('open');
            
            $('html').addClass('nav-opened');
            Menub.menubar.trigger('menuOpen');
        },

        Hide: function($menuitem) {
            if(!Menub.HasSubmenu($menuitem)) {
                return;
            }
            
            var $submenu = $menuitem.siblings('[data-submenu="true"]');
            $submenu.removeClass('open');
            $submenu.velocity('transition.fadeOut', {
                duration: 300,
                complete: function() {
                    
               }
            });
			$menuitem.removeClass('open');
            
            Menub.menubar.trigger('menuClose');
            setTimeout(function(){
                if(!Menub.topItems.hasClass('open')) {
                    $('html').removeClass('nav-opened');
                }
            },400);
        },
        
        /*
         * Close any open drop downs
         */
        Clear: function() {
            
            Menub.menubar.find('a.open[role=menuitem]').each(function(i,menuitem){
                Menub.DropDown.Hide($(menuitem));
            });
        }
    },
    
    Goto: {
        
        FirstTop: function() {
            Menub.DropDown.Clear();
            Menub.topItems.first().focus();
            Menub.topIndex = 0;
        },

        LastTop: function() {
            Menub.DropDown.Clear();  
            Menub.topItems.last().focus();
            Menub.topIndex = Menub.topItems.length - 1;
        },
        
        PreviousTop: function() {
            var nextIndex = Menub.topIndex - 1;
            if(nextIndex < 0) {
                nextIndex = Menub.topItems.length - 1;
            }
            
            Menub.DropDown.Clear();  
            Menub.topItems.eq(nextIndex).focus();
            Menub.topIndex = nextIndex;
        },
        
        NextTop: function() {
            var nextIndex = Menub.topIndex + 1;
            if(nextIndex > (Menub.topItems.length - 1) ) {
                nextIndex = 0;
            }
            if(!Menub.menubar.find(':focus').length) {
                nextIndex = 0;
            }

            Menub.DropDown.Clear();  
            Menub.topItems.eq(nextIndex).focus();
            Menub.topIndex = nextIndex;
        },
        
        /*
         * Close the drop down and change focus to the parent
         */
        Parent: function() {
            Menub.topItems.eq(Menub.topIndex).focus();
            Menub.DropDown.Clear();
        },
        
        /*
         * Go to the next menuitem sibling that starts with the given letter
         * or do nothing.
         */
        NextLetter: function(letter) {
            var $ulParent = $(':focus').parents('ul').first();
            if(!$ulParent.length) {
                return;
            }

            // Cycle through menuitems, looking for next
            var $elements = $ulParent.find('> li > a');
            var focusIndex = 0;
            var matchingElements = [];
            $elements.each(function(i,a){
                if($(a).is(':focus') || $(a).parent().is(':focus')) {
                    focusIndex = i;
                }
                var aText = $.trim($(a).text());
                var firstLetter = aText.substr(0,1).toUpperCase();
                if(firstLetter == letter) {
                    matchingElements.push(i);
                }
            });
            if(!matchingElements.length) {
                return;
            }

            var matchFound = false;
            var leastMatch = 999;
            $.each(matchingElements, function(i,e){
                if(e > focusIndex) {
                    matchFound = true;
                    $elements.eq(e).focus();
                    if($ulParent.attr('role') === 'menubar') {
                        NavKeys.currentIndex = e;
                    }
                    return false;
                }
                if(e < leastMatch) {
                    leastMatch = e;
                }
            });

            if(!matchFound && leastMatch < $elements.length) {
                $elements.eq(leastMatch).focus();
                if($ulParent.attr('role') === 'menubar') {
                    NavKeys.currentIndex = leastMatch;
                }
            }
        }
    },
    
    /*
     * The object belows handles the keyboard navigation while within the main nav
     * per ADA guidelines: 
     * https://www.w3.org/TR/wai-aria-practices-1.1/examples/menubar/menubar-1/menubar-1.html
     * 
    Menubar Behavior
        Space or Enter 	
            Open or Close popup menu (e.g. toggle). (Note, opening moves focus to first element, so closing isn't necessary)

        Left Arrow 	
            Moves focus to previous menubar menu item.
            If focus on first menubar menu item, focus is moved to last menubar menu item.

        Right Arrow 	
            Moves focus to next menubar menu item.
            If focus on last menubar menu item, focus is moved to first menubar menu item.

        Down Arrow 	
            Open popup menu.
            Moves focus to first popup menu item.

        Up Arrow 	
            Open popup menu.
            Moves focus to last popup menu item.

        Home 	
            Moves focus to first menubar menu item.

        End 	
            Moves focus to last menubar menu item.

        Character       
            Moves focus to next menubar item that starts with that letter.
            If no menubar menu item starts with the letter, focus does not move.

    ******
    Popup Menu Behavior
        Space or Enter 	
            Follow link.

        Escape 	
            Closes popup menu.
            Moves focus to current menubar menu item.

        Left Arrow 	
            Closes popup menu.
            Moves focus to previous menubar menu item.
            Open the popup menu of the previous menubar menuitem with focus.

        Right Arrow 
            Closes popup menu.
            Moves focus to next menubar menu item.
            Open the popup menu of the next menubar menuitem with focus.

        Up Arrow 	
            Moves focus to previous popup menu item.
            If first popup menu item, focus is moved to the last popup menu item.

        Down Arrow 	
            Moves focus to next popup menu item.
            If last popup menu item, focus is moved to the first popup menu item.

        Home 	
            Moves focus to first popup menu item.

        End 	
            Moves focus to last popup menu item.

        Character 	
            Moves focus to the next popup item that starts with that letter.
            If no popup menu item starts with the letter, focus does not move.

     */
    KeyControl: {
        
        Arrow: {
            
            Left: function() {
                // Are we in a submenu?
                var $ulParent = $(':focus').parents('ul').first();
                if(!$ulParent.length || $ulParent.attr('role') !== 'menu') {
                    Menub.Goto.PreviousTop();
                    return;
                }

                /*
                 * We are in a submenu.
                 * If this is a nested submenu, return focus to the parent submenu.
                 * Otherwise, move to previous top.
                 */
                if($ulParent.parents('ul[role=menu]').length) {
                    // It is nested
                    var $parentA = $ulParent.parents('[data-submenu=true]').first().siblings('a');
                    Menub.DropDown.Hide($parentA);
                    $parentA.focus();
                    return;
                }
                
                Menub.Goto.PreviousTop();
            },
            
            Right: function() {
                // Are we in a submenu?
                var $ulParent = $(':focus').parents('ul').first();
                if(!$ulParent.length || $ulParent.attr('role') !== 'menu') {
                    Menub.Goto.NextTop();
                    return;
                }
                
                /*
                 * We are in a submenu.
                 * If this menuitem has a nested submenu, open and focus that
                 * Otherwise, trigger next top.
                 */
                var $a = $(':focus');
                if(Menub.HasSubmenu($a)) {
                    Menub.DropDown.Show($a);
                    return;
                }
                
                Menub.Goto.NextTop();
            },
            
            Up: function() {
                // Are we in a submenu?
                var $ulParent = $(':focus').parents('ul').first();
                if(!$ulParent.length || $ulParent.attr('role') !== 'menu') {
                    // No, trigger left behavior
                    Menub.Goto.PreviousTop();
                    return;
                }
                
                // Move up the current submenu
                var currentIndex = 0;
                var numLis = 0;
                $ulParent.find('> li > a').each(function(i,li){
                    if($(li).is(':focus')) {
                        currentIndex = i;
                    }
                    numLis++;
                });
                
                var nextIndex = currentIndex - 1;
                if(nextIndex < 0) {
                    nextIndex = numLis - 1;
                }
                $ulParent.find('> li > a').eq(nextIndex).focus();
            },
            
            Down: function() {
                // Are we in a submenu?
                var $ulParent = $(':focus').parents('ul').first();
                if(!$ulParent.length || $ulParent.attr('role') !== 'menu') {
                    // Open current submenu
                    Menub.DropDown.Show(Menub.topItems.eq(Menub.topIndex));
                    return;
                }
                
                // Move up the current submenu
                var currentIndex = 0;
                var numLis = 0;
                $ulParent.find('> li > a').each(function(i,li){
                    if($(li).is(':focus')) {
                        currentIndex = i;
                    }
                    numLis++;
                });
                
                var nextIndex = currentIndex + 1;
                if(nextIndex >= numLis ) {
                    nextIndex = 0;
                }
                $ulParent.find('> li > a').eq(nextIndex).focus();
            }
        },
        
        /*
         * This function is typically called by an [Enter] or [Space] key.
         * If the item has a submenu, it will open that. Otherwise it will
         * allow the link to be followed.
         * 
         * The return value can seem backwards. A return of true means there
         * is no submenu and the link can be followed. A return of false means
         * a submenu was opened and no further action should be taken.
         */
        ActivateLink: function() {
            var $a = $('a:focus');
            
            if(!$a.length) {
                return true;
            }
            
            if(Menub.HasSubmenu($a)) {
                Menub.DropDown.Show($a);
                return false;
            }
            
            return true;
        },
        
        End: function() {
            // Are we on a menu or top menubar?
            var $ulParent = $(':focus').parents('ul').first();
            if(!$ulParent.length || $ulParent.attr('role') !== 'menu') {
                // trigger menubar home
                Menub.Goto.LastTop();
                return;
            }

            // Go to first submenu item
            $ulParent.find('> li > a').last().focus();
        },
        
        Home: function() {
            // Are we on a menu or top menubar?
            var $ulParent = $(':focus').parents('ul').first();
            if(!$ulParent.length || $ulParent.attr('role') !== 'menu') {
                // trigger menubar home
                Menub.Goto.FirstTop();
                return;
            }

            // Go to first submenu item
            $ulParent.find('> li > a').first().focus();
        }
    },
    
    /*
     * Determine whether the given <a> tag has a submenu associated.
     */
    HasSubmenu: function($a) {
        return $a.siblings('[data-submenu="true"]').length;
    }
};


window.dropdownShouldBeActive = function() {
    
    if($('#mbl-menu-icon').length && $('#mbl-menu-icon').is(':visible')) {
        return false;
    }
    
    return true;
}